export default function ($translate) {
    return {
        KEYS: {
            HOURS: 'HOURS',
            AHOURS: 'AHOURS',
            DAYS: 'DAYS',
            WEEKS: 'WEEKS'
        },
        LABELS: {
            HOURS: $translate.instant('courses.external.Hours'),
            AHOURS: $translate.instant('courses.external.Academic hours'),
            DAYS: $translate.instant('courses.external.Days'),
            WEEKS: $translate.instant('courses.external.Weeks')
        },
        SHORTEN: {
            HOURS: $translate.instant('courses.external.h'),
            AHOURS: $translate.instant('courses.external.a.h'),
            DAYS: $translate.instant('courses.external.d'),
            WEEKS: $translate.instant('courses.external.w')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/durationType/index.js